// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3QHVO","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3Zy1h"};